import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../event/data.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-membership-confirmation',
  templateUrl: './membership-confirmation.component.html',
  styleUrls: ['./membership-confirmation.component.css']
})
export class MembershipConfirmationComponent implements OnInit {

  constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router) { }

  loading = false;
  message = '';
  str = undefined;

  async ngOnInit(): Promise<void> {
    if(this.route.snapshot.queryParams['str1'] && this.route.snapshot.queryParams['str2']){
      let str1 = this.route.snapshot.queryParams['str1'];
      let str2 = this.route.snapshot.queryParams['str2'];
      await this.confimationRequestToDatabase(str1, str2);
    }
    else if(this.route.snapshot.queryParams['str']){
      let str = this.route.snapshot.queryParams['str'];
      this.str = str;

      await this.UserContact(str);
    }
    else if(!this.route.snapshot.queryParams['str1'] && !this.route.snapshot.queryParams['str2'] && !this.route.snapshot.queryParams['str'] ) {
      this.loading = true;
      window.location.href='https://vdu.de';
    } else {
      this.loading = true;
      window.location.href='https://vdu.de';
    }
  }

  async confimationRequestToDatabase(val1: String, val2: String){
    this.loading = true;

    const payload = { encodedstring1: val1, encodedstring2: val2 };

    this.dataService.postUserConfirmation(payload).subscribe( res => {
      const result = res;
      if(result){
        if(result['status_code']==200 && result['message']=='Registration Confirmed Successfully.'){
          this.loading = false;
          this.message = 'Wir werden Ihren Mitgliedsantrag nun bearbeiten und uns in Kürze bei Ihnen melden.Vielen Dank!';
          Swal.fire({
            title: "Ihre Bestätigung war erfolgreich.",
            text: "Wir werden Ihren Mitgliedsantrag nun bearbeiten und uns in Kürze bei Ihnen melden. Vielen Dank!",
            icon: "success"
          });
        } else if (result['status_code']==403 && result['message']=='Registration Already Confirmed.'){
          this.loading = false;
          this.message = 'Sie haben Ihre Bewerbung bereits bestätigt.';
          Swal.fire({
            title: "Sie haben Ihre Bewerbung bereits bestätigt.",
            html: "Wir werden uns in Kürze bei Ihnen melden.<br>Vielen Dank für Ihre Geduld.",
            icon: "info"
          }).then(()=> {
            window.location.href='https://vdu.de';
          });
        } else if (result['status_code']==403 && result['message']=='Confirmation Link is Invalid or Expired.'){
          this.loading = false;
          this.message = 'Leider ist der Bestätigungslink abgelaufen.';
          Swal.fire({
            title: "Liebe Unternehmerin,<br>leider haben Sie Ihren Antrag nicht fristgerecht bestätigt.",
            html: "Der Link ist aus Datenschutzgründen abgelaufen. Bitte füllen Sie Ihren Antrag erneut aus.<br>Vielen Dank!<br>Ihre VdU Mitgliederbetreuung",
            icon: "info"
          }).then(()=> {
            window.location.href='https://vdu.powerappsportals.com/membership';
          });
        }
      }
    });
  }

  async UserContact(val: String){
    this.loading = true;
    const payload = { encodedstring: val };

    this.dataService.postUserContact(payload).subscribe( res => {
      const result = res;
      if(result){
        if(result['status_code']==200 && result['message']=='Successfully Created Contact in CRM.'){
          this.message = 'Successfully Created Contact in CRM.'
          this.loading = false;
          Swal.fire({
            title: "Successful",
            text: "Contact is Successfully Created in CRM.",
            icon: "success"
          });
          this.router.navigate(['/home']);
        }
        else if (result['status_code']==403 && result['message']=='Already Registered.'){
          this.loading = false;
          this.router.navigate(['/home']);
          Swal.fire({
            title: "Sorry",
            text: "User is Already Registered.",
            icon: "info"
          });
        }
        else if (result['status_code']==404 && result['message']=='User not found in our Database.'){
          this.loading = false;
          this.router.navigate(['/home']);
          Swal.fire({
            title: "Sorry",
            text: "User not found in Database.",
            icon: "info"
          });
        }
        else {
          this.loading = false;
          this.router.navigate(['/home']);
          Swal.fire({
            title: "Something Went Wrong",
            text: "Please Try Again Later.",
            icon: "info"
          });
        }
      }
    });

  }


}
